import {
  API_BORROWING_BASE_ADVANCE_APPROVE,
  API_BORROWING_BASE_ADVANCE_DECLINE,
  API_BORROWING_BASE_ADVANCES,
  API_BORROWING_BASE_ADVANCES_APPROVE_BULK,
  API_BORROWING_BASE_ADVANCES_DECLINE_BULK,
  API_BORROWING_BASE_BY_ID,
  API_BORROWING_BASE_DOWNLOAD,
  API_BORROWING_BASE_PREVIEW,
  API_BORROWING_BASE_SUMMARY,
  API_BORROWING_BASES,
  API_BORROWING_BASES_ORDER,
} from 'config'
import Api from 'services/api'

import { downloadFile } from '../documents'

export const getBorrowingBases = () => {
  return Api.get(API_BORROWING_BASES)
}

export const createBorrowingBase = (name: string) => {
  return Api.post(API_BORROWING_BASES, { name })
}

export const updateBorrowingBase = (data: Record<string, any>, id?: number) => {
  return Api.put(API_BORROWING_BASE_BY_ID, data, { id })
}

export const removeBorrowingBase = (id: number) => {
  return Api.delete(API_BORROWING_BASE_BY_ID, {}, { id })
}

export const reorderBorrowingBases = (ids: number[]) => {
  return Api.put(API_BORROWING_BASES_ORDER, { ids })
}

export const generateBorrowingBasePreview = (id: number, paidInFull = false) => {
  return Api.post(API_BORROWING_BASE_PREVIEW, { paidInFull }, { id })
}

export const getBorrowingBaseSummary = (id: number) => {
  return Api.get(API_BORROWING_BASE_SUMMARY, {}, { id })
}

export const downloadBorrowingBaseReport = async (
  id: number,
  name: string,
  format: 'xlsx' | 'csv',
  filters: Record<string, any> = {},
) => {
  const res: Blob = await Api.post(
    API_BORROWING_BASE_DOWNLOAD,
    { filters },
    { id, format },
    { responseType: 'blob', timeout: 300000 },
  )
  const safeName = name.replace(/[\\/:*?"<>|]/g, '-')
  downloadFile(`Borrowing Base - ${safeName}.${format}`, res)
}

export const getBorrowingBaseAdvances = (id: number) => {
  return Api.get(API_BORROWING_BASE_ADVANCES, {}, { id })
}

export const requestBorrowingBaseAdvance = (id: number, loanNumbers: number[]) => {
  return Api.post(API_BORROWING_BASE_ADVANCES, { loanNumbers }, { id })
}

export const requestBorrowingBaseDraw = (id: number, loanNumber: number, drawData: Record<string, any>) => {
  return Api.post(API_BORROWING_BASE_ADVANCES, { type: 'draw', loanNumber, drawData }, { id })
}

export const approveBorrowingBaseAdvance = (id: number, advanceId: number) => {
  return Api.put(API_BORROWING_BASE_ADVANCE_APPROVE, {}, { id, advanceId })
}

export const declineBorrowingBaseAdvance = (id: number, advanceId: number, declineReason: string) => {
  return Api.put(API_BORROWING_BASE_ADVANCE_DECLINE, { declineReason }, { id, advanceId })
}

export const approveBorrowingBaseAdvances = (id: number, advanceIds: number[]) => {
  return Api.put(API_BORROWING_BASE_ADVANCES_APPROVE_BULK, { advanceIds }, { id })
}

export const declineBorrowingBaseAdvances = (id: number, advanceIds: number[], declineReason: string) => {
  return Api.put(API_BORROWING_BASE_ADVANCES_DECLINE_BULK, { advanceIds, declineReason }, { id })
}
